import React from 'react'
import { FavoriteEmptyIcon } from 'components/Utils/Icons'
import {
  ExpandableRowLayout,
  ExpandableRowLayoutProps,
} from '../ExpandableRowLayout'

export const BOOKMARKED_NOTES_SECTION_ID = `bookmarked-notes-section`

export type BookmarkedNotesSectionHeaderProps = Pick<
  ExpandableRowLayoutProps,
  'onToggleExpand' | 'isExpanded'
>

export const BookmarkedNotesSectionHeader = ({
  isExpanded,
  onToggleExpand,
}: BookmarkedNotesSectionHeaderProps) => (
  <ExpandableRowLayout
    id={BOOKMARKED_NOTES_SECTION_ID}
    onToggleExpand={onToggleExpand}
    isExpanded={isExpanded}
    depth={0}
    label="Favorite docs"
    icon={<FavoriteEmptyIcon size={14} />}
  />
)
